/* Publish by EComposer at 2026-10-06 07:06:36*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-60ac0dx8pst"]=  window.__ectimmers["ecom-60ac0dx8pst"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-60ac0dx8pst').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-60ac0dx8pst', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ub4mskpzupr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ub4mskpzupr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zidlpjfr4zh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zidlpjfr4zh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-12iqjsm10tr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-12iqjsm10tr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mrp66ci1fea').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mrp66ci1fea', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-leg1rlr8gga').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-leg1rlr8gga', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i9cbmqybb5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i9cbmqybb5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5zeeufs0sdb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5zeeufs0sdb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-urekifcrfoj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-urekifcrfoj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-is96agbxrn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-is96agbxrn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kmymht01iy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kmymht01iy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0r6vpf0ft5kq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0r6vpf0ft5kq', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-0gipjuf3m3y9"]=  window.__ectimmers["ecom-0gipjuf3m3y9"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const o=t.querySelector(".ecom__element--button");if(!o)return;let n=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-0gipjuf3m3y9"]["2y2674102"] = setInterval(function(){o.classList.add("animated"),setTimeout(function(){o.classList.remove("animated")},s)},n)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let o=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const n=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},o);try{Shopify.analytics.publish("ec_custom_events",n)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-0gipjuf3m3y9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0gipjuf3m3y9', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o3rab3wy7g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o3rab3wy7g', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-91r7kb0dlxv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-91r7kb0dlxv', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s0o9ze8vmu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s0o9ze8vmu', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-050hshpq6qd4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-050hshpq6qd4', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3nwbgbjnzib').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3nwbgbjnzib', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zuoezdtsl2m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zuoezdtsl2m', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zpg3e8m3n4m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zpg3e8m3n4m', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-9lh549dnvaf"]=  window.__ectimmers["ecom-9lh549dnvaf"] || {};
if(!this.$el||!window.EComModal)return;const t=this.isLive;let e=this.$el.querySelectorAll("[ecom-modal]");e.length&&t&&new window.EComModal(e,{gallery:!0,cssClass:["ecom-container-lightbox-"+this.id]})

                    });
                    
                        document.querySelectorAll('.ecom-9lh549dnvaf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9lh549dnvaf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m1t0ylayzag').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m1t0ylayzag', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7uj6a33t0jp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7uj6a33t0jp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jff57p2tpql').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jff57p2tpql', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lts41tx9h1m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lts41tx9h1m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fwr0ecr58bv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fwr0ecr58bv', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}